/**
 * @fileoverview Loading component.core
 * componentを継承しないため、正確には、componentではないが、機能として考えたcoreに格納する。
 */
'use strict';
// React Import
import React from 'react';
// Library Import
import _ from 'lodash';

/**
 * ローディング
 *
 * @class Loading
 */
class Loading {
  constructor() {
    _.bindAll(this, 'getRefLoading');
  }

  /**
   * ローディングの参照取得
   *
   * @param {Object} node ノード情報
   * @returns
   * @memberof Loading
   */
  getRefLoading(node) {
    if (_.isEmpty(node)) {
      return;
    }
    this.refLoading = node;
  }

  /**
   * ローディングエレメント取得
   *
   * @returns 要素
   * @memberof Loading
   */
  getElement() {
    return (
      <div id="loading-area" ref={this.getRefLoading}>
        <div className="loading-animation" />
      </div>
    );
  }

  /**
   * ローディング表示判定
   *
   * @returns {boolean} true:ローディング表示 false:ローディング非表示
   * @memberof Loading
   */
  isShow() {
    if (this.refLoading.style.display === 'block') {
      return true;
    }
    return false;
  }

  /**
   * ローディング表示
   *
   * @memberof Loading
   */
  show() {
    this.refLoading.style.display = 'block';
  }

  /**
   * ローディング非表示
   * @memberof Loading
   */
  hide() {
    this.refLoading.style.display = 'none';
  }
}

export default new Loading();



// WEBPACK FOOTER //
// ./src/js/component/core/Loading.jsx